module.exports = __webpack_public_path__ + "img/sn_1.d3bf0563.jpg";